import React from 'react';
import PuzzleDropDownButton from '../../../UI/button/dropdown/PuzzleDropDownButton';
import AuthService from '../../../../dispatcher/authentication/services/AuthService';
import Container from '../../container/Container';
import { Avatar } from '@progress/kendo-react-layout';
import { Component } from '../../../../dispatcher/modules';
import PuzzleButton from '../../../UI/button/PuzzleButton';
import ThemeService from '../../../../dispatcher/services/theme/ThemeService';
import { CookieUtil } from '../../../../utility';
import { COOKIE } from '../../../../dispatcher/config/Constants';
import _ from 'lodash';
import { HEADER_PROPS, HEADER_STATE } from './Types';

class Header extends Component<HEADER_PROPS, HEADER_STATE> {
  constructor(props: HEADER_PROPS) {
    super(props);

    this.state = {
      ...this.state,
      ...props,
      userDropDownOptions: []
    };
  }

  onItemClick = (item: any) => {
    let actionName = item.item.action || item.item.icon; // TODO currently icon property holds value of action which will be executed, enable to pass additional params to kendo DropDownButtonItem
    actionName && this.dispatch(actionName);
  };

  /**
   * Sets `state`s `userInfo` value.
   *
   * @param {any} userInfo
   */
  setUserInfo = (userInfo: string) => {
    this.setState({ userInfo });
  };

  /**
   * Sets `state`s `userDropDownOptions` value.
   *
   * @param {String} userDropDownOptions
   */
  setUserDropDownOptions = (userDropDownOptions: any[]) => {
    this.setState({ userDropDownOptions });
  };

  shouldComponentUpdate(props: any, state: any) {
    return state.userInfo?.userName !== this.translate('userMenu.defaultName');
  }

  initialData(isAuthenticated: Promise<boolean> = AuthService.isAuthenticated()) {
    const userMenuLocale = this.translate('userMenu') as any;

    const isAuthUserDropOptions = [{
      text: userMenuLocale.logout,
      action: 'signOutWarning'
    }];

    const { showHelpCenter = true } = this.props;

    if (showHelpCenter) {
      isAuthUserDropOptions.unshift({
        text: userMenuLocale.helpCenter,
        action: 'openHelpCenter'
      });
    }

    this.setState({
      userInfo: isAuthenticated ? this.state.userInfo : {
        userName: userMenuLocale.defaultName
      },
      // eslint-disable-next-line array-bracket-newline
      userDropDownOptions: isAuthenticated ? isAuthUserDropOptions : [{
        text: userMenuLocale.signin,
        action: 'redirectToSignIn'
      }]
    });
  }

  /**
   * @inheritDoc
   */
  moduleDidMount = () => {
    this.initialData();
  };

  /**
   * Open help center handler
   * @param userInfo
   * @param configData
   * @param url
   */
  openHelpPage = (userInfo: any, configData: any, url: string = null) => {
    // TODO uncomment for next iteration so help link is matched with current version of PD and uses config.json for languages
    // const locale = _.get(userInfo, 'preferences.language.locale');
    // const helpUserProfile = _.get(userInfo, 'userProfile.userInfo');
    // let helpLinks = _.get(configData, 'helpLinks');
    // let helpUrl = '';
    // const { subtype, userType } = helpUserProfile;
    // const subTypeLocale = helpLinks[subtype];
    // const userTypeLocale = helpLinks[userType];
    //
    // if (subTypeLocale) {
    //   helpUrl = this.getUrlByLocale(subTypeLocale, locale);
    // } else if (userTypeLocale) {
    //   helpUrl = this.getUrlByLocale(userTypeLocale, locale);
    // }
    //
    // if (helpUrl) {
    //   let version = _.get(userInfo, 'version');
    //   version = version.match(/([\w\s]+?\.){2}/)[0].slice(0, -1);
    //   window.open(helpUrl.replace('{0}', version), 'helpURL');
    // }
    if (!url) {
      url = '';
    }
    window.open(url);
  };

  /**
   * Returns help url for given locale
   * if locale doesn't exist returns default url
   */
  getUrlByLocale = (typeLocale: any, locale: string) => locale && typeLocale[locale] ? typeLocale[locale] : typeLocale['default_url'];

  /**
   * Switches current theme and stores selection on server
   */
  toggleTheme = (): void => {
    let { theme, themes } = this.state;
    const keys = Object.keys(themes);

    let currentTheme = theme || CookieUtil.get(COOKIE.THEME);
    currentTheme && (currentTheme = currentTheme.split('.')[0]);
    currentTheme = _.isNull(currentTheme) || currentTheme === keys[0] ? themes[keys[1]].name : themes[keys[0]].name;

    CookieUtil.setTheme(currentTheme);
    this.setState({ theme: currentTheme });
    ThemeService.loadStylesheet(currentTheme);
  };

  renderBody() {
    const { userDropDownOptions, userInfo, theme } = this.state;
    const isDarkTheme: boolean = !!(theme && theme.length && theme.includes('dark'));
    const themeBtnClass = isDarkTheme ? 'tp-icon tp-dark-mode' : 'tp-icon tp-light-mode';
    const themeBtnLabel = isDarkTheme ? this.translate('SRL-switchLightModeBtn') : this.translate('SRL-switchDarkModeBtn');

    const menuItems = userDropDownOptions.map((item: any) => ({
      text: item.text || '',
      icon: item.action
    }));
    const userMenuLocale = this.translate('userMenu') as any;

    let userDisplayName = userMenuLocale.defaultName || 'Guest';
    if (userInfo?.firstName) {
      userDisplayName = `${userInfo.firstName} ${userInfo.lastName}`;
    } else {
      if (userInfo?.userName) {
        userDisplayName = userInfo.userName;
      }
    }

    return (
      <Container
        hBox
        alignItemsCenter
        justifyContentBetween
        className="tp-viewport-header tp-100"
      >
        <Container className={'tp-header-logo-wrap'} />

        <Container hBox>

          <PuzzleButton
            aria-label={themeBtnLabel}
            titleText={themeBtnLabel}
            onClick={this.toggleTheme}
            className={'tp-theme-button'}
            iconClass={themeBtnClass}
            fillMode={'flat'}
            tooltipPosition={'bottom'}
            withTooltip
          />

          <Container
            hBox
            className={'tp-profile-button'}
            dataCy={'profile-button-wrapper'}
          >
            <Avatar
              rounded={'full'}
              className={'tp-avatar k-avatar-circle'}
            >
              <span aria-hidden={'true'}>
                {userDisplayName.charAt(0).toUpperCase()}
              </span>
            </Avatar>
            <PuzzleDropDownButton
              className={'tp-username-button'}
              iconClass={'tp-icon tp-arrow-chevron-down'}
              reverse
              onOpen={() => this.initialData()}
              onItemClick={this.onItemClick}
              text={userDisplayName}
              items={menuItems}
              textField={'text'}
              fillMode={'flat'}
              popupSettings={{
                anchorAlign: { horizontal: 'right', vertical: 'bottom' },
                popupAlign: { horizontal: 'right', vertical: 'top' }
              }}
            />
          </Container>
        </Container>
      </Container>
    );
  }
}

export default Header;
